import React, { useEffect, useState } from "react";
import DataTableLayer from "../../components/DataTableLayer";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import PostByAgg from "../../utils/axios";
import Modal from "../../components/Modal";
import MusicLabelForm from "./MusicLabelForm";
import ModalAlert from "../../components/ModalAlert";
import ModalHistory from "./MusicLabelHistory";
import LottieLoading from "../../components/child/LottieLoading";
const MusicLabel = () => {

    const columns = [
        {
        accessorKey: "city_name",
        header: "City",
        },
        {
            accessorKey: "music_label_name",
            key:'Label Name',
            header: "Label Name",
        },
        {
            accessorKey:"label_type_name",
            header:"Label Type",
        },
        {
            accessorKey: "address",
            header: "Address",
        },
        {
            accessorKey: "email",
            header: "Email",
        },
        {
            accessorKey: "telephone",
            header: "Telephone",
        },
        {
            accessorKey:"percentage",
            header:"Percentase",
        },
        {
            accessorKey: "status_name",
            header: "Status",
            cell: ({ row }) => {
            const status = row.getValue("status_name");
                let badgeColor;
            switch (status) {
                case "WAITING":
                badgeColor = "bg-warning";
                break;
                case "APPROVED":
                badgeColor = "bg-success";
                break;
                case "ACTIVE":
                badgeColor = "bg-success";
                break;
                case "PENDING":
                badgeColor = "bg-orange";
                break;
                case "REJECTED":
                badgeColor = "bg-danger";
                break;
                case "ON PROGRESS":
                badgeColor = "bg-primary";
                break;
                case "TERMINATED":
                badgeColor = "bg-red";
                break;
                default:
                badgeColor = "bg-secondary";
                break;
            }
        if (status === "APPROVED" || status === "REJECTED" || status === "TERMINATED") {
                return (
                  <span className={`badge ${badgeColor}`}>{status}</span>
                );
              } else {
                return (
                  <span onClick={() => handleApproval(row)} className={`badge ${badgeColor} cursor-pointer`}>{status}</span>
                );
              }
                // return (
                //     <span 
                //     onClick={() => handleApproval(row)} 
                //     className={`badge ${badgeColor} cursor-pointer`}>{status}</span>
                // );
            },
        },
        {
            accessorKey: "action", // Add a custom column for actions
            header: "Actions",
            cell: ({ row }) => (
                <div className="dropdown">
                    <button
                        className="btn px-18 py-11 text-primary-light"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <Icon
                            icon="ph:dots-three-outline-fill"
                            className="menu-icon"
                        />
                    </button>
                    <ul className="dropdown-menu">
                        <li>
                            <Link
                                className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                to="#"
                                onClick={() => handleAction('view', row)}
                            >
                                View
                            </Link>
                        </li>
                        <li>
                            <Link
                                className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                to="#"
                                onClick={()=> handleAction('delete', row)}
                            >
                                Delete
                            </Link>
                        </li>
                        <li>
                            <Link
                                className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                to="#"
                                onClick={()=> handleAction('history', row)}
                            >
                                History
                            </Link>
                        </li>
                    </ul>
                </div>
            ),
            },
    ];

    const [listLabel, setListLabel] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 0,
        totalRecords: 0,
        totalPages: 0,
    });
    const [openModal, setOpenModal] = useState(false);
    const [openModalAlert, setOpenModalAlert] = useState(<div></div>);
    const [selectedRow, setSelectedRow] = useState('');
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedPartner,setSelectedPartner] = useState(false);
    const [openModalView, setOpenModalView] = useState(false);
    const [selectedRowView, setSelectedRowView] = useState({});
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [description, setDescription] = useState('');
    const [percent,setPercent] = useState(0);
    const [openModalHistory, setOpenModalHistory] = useState(false);
    const [selectedHistoryData, setSelectedHistoryData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);


    // const loggedInUser = sessionStorage.getItem('user');
    // const "admin" = JSON.parse(loggedInUser).name;
  
        const GetListLabel = () => {
            setIsLoading(true);
          const url = 'label/lm/v1/music-label/list';
          PostByAgg({
              url: url,
              body: {
                  "page": pagination.pageIndex + 1,
                  "page_size": pagination.totalRecords,
                  
              },
              onResponse:onResponseListLabel,
              onError:onErrorListLabel
          })
       }
  
       useEffect(() => {  
          GetListLabel();
       }, [pagination.pageIndex, pagination.pageSize]);


  
  
    const onResponseListLabel = (response) => {
      console.log("Response List Label: ", response.data.data)
      if(response.data.code === '2002000' || response.data.data.data === null){
          const totalRecords = response.data.data.total_records;
          const totalPages = Math.ceil(totalRecords / pagination.pageSize);
          setPagination((prev) => ({
              ...prev,
              totalRecords: totalRecords,
              totalPages: totalPages,
              pageSize: totalRecords,
              // pageIndex: 0,
            }));
            setIsLoading(false)
           setListLabel(response.data.data.data)
      }else{
        setIsLoading(false)
        setListLabel([])
      }
    }
  
    const onErrorListLabel = (error) => {
      console.log("Error List Label: ", error)
      if(error.response){
        setOpenModalAlert(<ModalAlert
            show={true}
            text={error.response.data}
            type={"failed"}
            action={() => {}}
            />
        )
      }
    }

    const DeleteLabel = (music_label_code) => {
        const url = `label/lm/v1/music-label/delete`; 
        PostByAgg({
          url: url,
          body: {
            'music_label_code': music_label_code
          },
          onResponse: onDeleteResponse,
          onError: onDeleteError,
        });
      };
    
      function onDeleteResponse(response) {
        console.log("Delete Response: ", response.data);
        if (response.data && response.data) {
            console.log("Data has been deleted successfully!");
            setTimeout(() => {
                // handleCloseModal();
                // GetListLabel();
                setShowSuccessModal(
                    <ModalAlert
                    show={true}
                        title="Success"
                        type="success"
                        message={'Delete '+ response.data.message.id}
                        action={() => {
                            setShowSuccessModal(<div></div>)
                            handleCloseModal();
                            GetListLabel();
                        }}
                        />
                )
            }, 500);
        } else {
            console.error("Error deleting label: ", response.data);
            setShowSuccessModal(
                <ModalAlert
                    show={true}
                    type={"failed"}
                    message={response.data.message.id}
                    action={() => {
                        setShowSuccessModal(<div></div>)
                        handleCloseModal();
                        GetListLabel();
                    }}
                />
            )
        }
        // setShowSuccessModal(true);
        setShowConfirmModal(false);
        GetListLabel();
        
      }
    
      function onDeleteError(error) {
        if(error.response) {
            setShowSuccessModal(
                <ModalAlert
                    show={true}
                    type={"failed"}
                    message={error.data.message.id}
                    action={() => {
                        setShowSuccessModal(<div></div>)
                        handleCloseModal();
                        GetListLabel();
                    }}
                />
            )
        }
      }
  
    const handleAction = (action, row) => {
      // Handle different actions based on the clicked item
      console.log(`Action: ${action}, Row ID: ${row.original.id}`);
      if (action === 'view') {
        setSelectedRowView(row);
        setOpenModalView(true);
      } else if (action === 'delete') {
        // Logic to delete
        setSelectedRow(row.original);
        setShowConfirmModal(true)
      } else if (action === 'history') {
        // Logic to history
        setSelectedHistoryData(row.original)
        setOpenModalHistory(true)
        fetchHistoryData(row.original.music_label_code);
        console.log("History", row.original.music_label_code)
      }
    };

    const handleApproval = (row) => {

      console.log("Approval")
      console.log("ROW: ", row)
      setSelectedRow(row.original)
      setOpenModal(true)
      setDescription('');
      setPercent(0)

    }

    const handleSubmitApproval = () => {
        console.log("Submit Approval")
        console.log("Row: ", selectedRow.music_label_code)
        setIsLoading(true)
        const url = `label/lm/v1/music-label/update-status`;
        PostByAgg({
            url: url,
            body: {
                'music_label_code': selectedRow.music_label_code,
                'status_code': selectedStatus,
                'is_partner': selectedPartner,
                'description': description,
                'percentage': parseInt(percent),
                "updated_by": "admin"
            },
            onResponse: onStatusApprovalResponse,
            onError: onStatusApprovalError,
          });
    }

    const onStatusApprovalResponse = (response) => {
        console.log("Status Approval Response: ", response.data)
        setIsLoading(false)
        setShowSuccessModal(
            <ModalAlert
                show={true}
                type={"success"}
                message={response.data.message.en}
                action={() => {
                    setShowSuccessModal(<div></div>)
                    handleCloseModal();
                    GetListLabel();
                }}
            />
        )
    }

    const onStatusApprovalError = (error) => {
        console.log("Status Approval Error: ", error)
        setShowSuccessModal(
            <ModalAlert
                show={true}
                type={"failed"}
                message={error.response.data.message}
                action={() => {
                    handleCloseModal();
                    GetListLabel();
                }}
            />
        )
    }

    const handleCloseModal = () => {
      setOpenModal(false);
      setSelectedStatus(null);
      setSelectedRow('')
    };

    const handleCloseModalForm = () => {
        setOpenModalView(false);
        setShowConfirmModal(false)
    };

    const listStatus = [
        // {
        //     value: "ST2411082239045",
        //     label: "WAITING"
        // },
        {
            value: "ST2411050431544",
            label: "APPROVED"
        },
        {
            value: "ST2411115202158",
            label: "ACTIVE"
        },
        {
            value: "ST2411052869827",
            label: "PENDING"
        },
        {
            value: "ST2411058629344",
            label: "REJECTED"
        },
        {
            value: "ST2411111068750",
            label: "ON PROGRESS"
        },
    ]

    const fetchHistoryData = (selectedRow) => {
        setIsLoading(true);
        const url = `history/v1/music-label/list`;
        PostByAgg({
          url: url,
          body: {
            "page": 1,
            "page_size": 10,
            'music_label_code': selectedRow.music_label_code,
            "keyword" : selectedRow.status_name
          },
          onResponse: onHistoryResponse,
          onError: onHistoryError,
        });

    };

        const onHistoryResponse = (response) => {
            console.log("History Response: ", response.data.data)
            // setIsLoading(false);
            if(response.data.data.data.length > 0) {
            setIsLoading(false);
            setSelectedHistoryData(response.data.data.data);
            }else{
                setIsLoading(false);
                setSelectedHistoryData([]);
            }
        }

        const onHistoryError = (error) => {
            if(error.response) {
                <ModalAlert 
                    show={true} 
                    type={"failed"}
                    text={error.response.data.message} 
                    action={()=>{}}
                    />
            }
        }
      
      return (
          <div>
             <DataTableLayer 
             data={listLabel} 
             columns={columns} 
             title={"Music Label Table"} 
             pagination={pagination}
             handleAction={handleAction}
             showButton={false}
             />
             {
                openModal && (
                    <Modal
                      open={openModal}
                      onClose={handleCloseModal}
                      title={selectedRow.music_label_name}
                      Submit={handleSubmitApproval}
                    >
                        <div className="mb-3">
                            <label className="col-form-label" htmlFor="status">Status :</label>
                            <select className="form-select form-select-lg mb-3" defaultValue={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)} >
                                <option>Pilih </option>
                                {listStatus.map((status, index) => {
                                    if (status.label !== selectedRow.status_name) { 
                                        return (
                                            <option key={index} value={status.value}>
                                                {status.label}
                                            </option>
                                        );
                                    }
                                    return null;
                                })}
                            </select>
                           
                            {
                                selectedStatus === "ST2411050431544" ? (
                                    <>
                                        <div className="mb-3">
                                            <label className="col-form-label" htmlFor="isPartner">Is Partner :</label>
                                            <select className="form-select form-select-lg mb-3" defaultValue={selectedStatus} onChange={(e) => setSelectedPartner(JSON.parse(e.target.value))} >
                                                <option>Pilih </option>
                                                <option value="true">Yes</option>
                                                <option value="false">No</option>
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                        <label className="col-form-label" htmlFor="status_name">
                                            Persentase:
                                        </label>
                                        <input
                                            type="number"
                                            className={`form-control`}
                                            id="percent"
                                            min={0}
                                            max={100}
                                            name="percent"
                                            defaultValue={percent || 0}
                                            onChange={(e) => setPercent(e.target.value)}
                                        />
                                        </div>
                                    </>
                                ):(
                                selectedStatus != null && (
                                    <>
                                        <div className="mb-3">
                                            <label htmlFor="message-text" className="col-form-label">Message:</label>
                                            <textarea className="form-control" id="message-text" defaultValue={description} onChange={(e) => setDescription(e.target.value)} cols={"30"} rows={"5"}></textarea>
                                        </div>
                                        <div className="mb-3">
                                        <label className="col-form-label" htmlFor="status_name">
                                            Persentase:
                                        </label>
                                        <input
                                            type="number"
                                            className={`form-control`}
                                            id="percent"
                                            name="percent"
                                            min={0}
                                            max={100}
                                            defaultValue={percent}
                                            onChange={(e) => setPercent(e.target.value)}
                                        />
                                    </div>
                                    </>
                                )
                                )
                            }
                            
                        </div>
                    </Modal>
             )}

            {
            openModalView && (
               
                <MusicLabelForm
                    data={selectedRowView}
                    open={openModalView}
                    mode="view"
                    onClose={handleCloseModalForm}
                    onSubmit={() => {}}
                />
            )
            }

            {showConfirmModal && (
                    <ModalAlert
                    show={true}
                    type="confirm"
                    code="Delete Confirmation"
                    text={`Are you sure you want to delete this ${selectedRow?.music_label_name}?"`}
                    open={showConfirmModal}
                    action={() => {
                        DeleteLabel(selectedRow.music_label_code)
                    }}
                    cancel={handleCloseModalForm}
                    />
                )}

                {openModalHistory && (
                <ModalHistory
                    open={openModalHistory}
                    onClose={() => setOpenModalHistory(false)}
                    data={selectedHistoryData}
                    isLoading={isLoading}
                />
                )}

                {
                    isLoading && <LottieLoading text="Loading..." /> 
                }

                {showSuccessModal}
                {openModalAlert}
          </div>
          
      );
  };


export default MusicLabel